<div class="table-wrapper">

  <div class="ag-theme-quartz table-grid">

    <ag-grid-angular
  class="ag-grid ag-theme-quartz ag-grid"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [rowSelection]="'multiple'"
  [suppressRowClickSelection]="true"
  [overlayNoRowsTemplate]="'<span>No Data Found</span>'"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged()"
  (rowClicked)="onRowClicked($event)"
  (cellClicked)="onCellClicked($event)">
</ag-grid-angular><!--[loading]="loading"-->

  </div>
@if (showPagination  && totalPages > 0) {

<div class="pagination-container">

  <div class="pagination-left">

    <button
      (click)="goFirstPage()"
      [disabled]="currentPage === 1">
      ⏮ First
    </button>

    <button
      (click)="previousPage()"
      [disabled]="currentPage === 1">
      ‹ Previous
    </button>

  </div>

  <div class="page-info">

    <span>
      Page {{ currentPage }} of {{ totalPages }}
    </span>

    <select
  class="page-size-select"
  [ngModel]="pageSize"
  (change)="onPageSizeChange($event)">

  @for (option of pageSizeOptions; track option) {
    <option [value]="option">
      {{ option === totalRecords ? 'All' : option }}
    </option>
  }

</select>

  </div>

  <div class="page-info">

    Showing Records
    {{ rowData.length }}
    of
    {{ totalRecords }}

  </div>

  <div class="pagination-right">

    <button
      (click)="nextPage()"
      [disabled]="currentPage === totalPages">
      Next ›

    </button>

    <button
      (click)="goLastPage()"
      [disabled]="currentPage === totalPages">
      Last ⏭
    </button>

  </div>

</div>

}
</div>
